import NavBar from './NavBar';
import GalleryView from './GalleryView';

const GalleryPage = () => {
    return (
        <div className="App-header">
            <NavBar />
            <div className="generator-display">
                <GalleryView />
            </div>
        </div>
    );
};

export default GalleryPage;
